export const PAGE_HEADER_DISPLAY = {
  PLAYER: 'player',
  TEAM: 'team',
  CUSTOM: 'custom',
  BLANK: 'blank',
  GAME: 'game',
};
